import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import { enviroment } from '@utils/config';

const languages = ['es', 'en'];
const resources = {
  // eslint-disable-next-line global-require
  es: { translation: require('@assets/translations/es.json') },
  // eslint-disable-next-line global-require
  en: { translation: require('@assets/translations/en.json') },
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    debug: enviroment.isDev || false,
    whitelist: languages,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
